import { checkWhitelabelClients } from '@moovly/whitelabel';
export const checkClientForStaging = () => {
  if (import.meta.env.MOOVLY_APP_API_ENVIRONMENT !== 'staging') {
    checkWhitelabelClients({});
    return;
  }
};
